import {Property} from "@/entities/questionaire/Property"
import {Answer} from "@/entities/questionaire/answers/Answer"
import {Recommendation} from "@/entities/questionaire/Recommendation";
import {SpecialNote} from "@/entities/questionaire/SpecialNote";
import { AnswerType } from './answers/AnswerType';

export class QuestionnaireResult {
    recommendations: Recommendation[];
    specialNotes: SpecialNote[];

    constructor(recommendations: Recommendation[], specialNotes: SpecialNote[]) {
        this.recommendations = recommendations;
        this.specialNotes = specialNotes;
    }

    hasRecommendations(): boolean {
        return this.recommendations != null && this.recommendations.length > 0;
    }

    hasSpecialNotes(): boolean {
        return this.specialNotes != null && this.specialNotes.length > 0;
    }
}
